import { render, staticRenderFns } from "./Careplans.vue?vue&type=template&id=70fd4c8c&scoped=true&"
import script from "./Careplans.vue?vue&type=script&lang=js&"
export * from "./Careplans.vue?vue&type=script&lang=js&"
import style0 from "./Careplans.vue?vue&type=style&index=0&id=70fd4c8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fd4c8c",
  null
  
)

export default component.exports